<template>

  <div class="pageTableUsers">
    <div class="row justify-content-center my-5">
      <div class="col-12">
        <div class="card-diagram-info d-flex justify-content-between">
          <h2>dd.mm.rrrr – dd.mm.rrrr</h2>
          <div class="wrapper-btn">
            <b-button variant="secondary"
                      class="custom px-5 mr-3">
              <span class="icon icon-print pr-2"></span>

              Drukuj
            </b-button>
            <b-button variant="primary"
                      class="custom px-5">
              <span class="icon icon-save pr-2"></span>

              Zapisz
            </b-button>

          </div>
        </div>
      </div>

    </div>
    <div class="row">
      <div class="col-12">
        <b-table
          striped
          :items="items"
          :fields="fields"
          :per-page="perPage"
          :current-page="currentPage"
          class="custom table-users"
          :tbody-tr-class="rowClass"
        >
          <template slot="top-row" :columns="fields.length" slot-scope="data" :class="'sub-header'">
            <td :key="key" v-for="(field, key) in fields">
              <template v-if="key === 4" >

                <b-dropdown id="dropdown-1" text="" size="sm"
                            variant="defoult" class="custom t-btn ">
                  <b-dropdown-item>First Action</b-dropdown-item>
                  <b-dropdown-item>Second Action</b-dropdown-item>
                  <b-dropdown-item>Third Action</b-dropdown-item>
                </b-dropdown>

              </template>
              <template v-else-if="key === 5"/>
              <template v-else class="qwe">
                <div class="d-flex">


                  <!-- <b-form-input class="custom sm search"></b-form-input>-->
                  <div class="input-group sm custom search ">

                    <input type="text"
                           class="form-control sm custom"
                           placeholder="test"
                           aria-label="Username"
                           aria-describedby="basic-addon1">
                    <div class="input-group-prepend">
                      <a href="#">
                        <span class="input-group-text icon-search icon px-0"></span>
                      </a>
                    </div>
                  </div>
                  <b-dropdown size="sm" variant="link" toggle-class="text-decoration-none" >
                    <template slot="button-content"><span class="sr-only custom">Search</span></template>
                    <b-dropdown-item href="#">Action</b-dropdown-item>
                    <b-dropdown-item href="#">Another action</b-dropdown-item>
                    <b-dropdown-item href="#">Something else here...</b-dropdown-item>
                  </b-dropdown>
                </div>
              </template>
            </td>
          </template>

          <template slot="status" slot-scope="scope">
            <p class="border-status custom " :class="scope.item.status ? 'border-success' : 'border-danger'">
              {{scope.item.status}}</p>
          </template>

          <template slot="actions" slot-scope="scope">
            <div class="wrap-ico-btn d-flex justify-content-between">
              <a href="" class="#">
                <span class="icon icon-open"></span>
              </a>
              <a href="" class="#">
                <span class="icon icon-edit"></span>
              </a>
              <a href="" class="#">
                <span class="icon icon-delete"></span>
              </a>
            </div>
          </template>
        </b-table>
      </div>
    </div>
    <b-row>

      <b-pagination
        v-model="currentPage"
        :total-rows="totalRows"
        :per-page="perPage"
        class=" custom"
      ></b-pagination>

    </b-row>
  </div>

</template>

<script>


  export default {
    name: 'TableUsers',

    components: {
    },
    data () {
      return {
        currentPage: 1,
        currentPage2: 1,
        totalRows: 1,
        totalRows2: 1,
        perPage: 3,
        perPage2: 3,
        items: [
          {
            fullname: 'Stephen Hawking',
            firmName: 1,
            outpostAddress: false,
            role: true,
            status: true,
            type2c: false,
            type3: false
          },
          {
            fullname: 'Johnny Appleseed',
            firmName: 2,
            outpostAddress: false,
            role: true,
            status: true,
            type2c: false,
            type3: false
          },
          {
            fullname: 'George Washington',
            firmName: 3,
            outpostAddress: false,
            role: false,
            status: false,
            type2c: false,
            type3: true
          },
          {
            fullname: 'Albert Einstein',
            firmName: 4,
            outpostAddress: true,
            role: false,
            status: false,
            type2c: true,
            type3: false
          },
          {
            fullname: 'Isaac Newton',
            firmName: 5,
            outpostAddress: true,
            role: true,
            status: false,
            type2c: true,
            type3: false
          }
        ],
        fields: [
          // 'name',
          { key: 'fullname', label: 'Imię i nazwisko', sortable: true },
          { key: 'firmName', label: 'Nazwa firmy', sortable: true },
          { key: 'outpostAddress', label: 'Adres placówki', sortable: true },
          { key: 'role', label: 'Rola', sortable: true },
          { key: 'status', label: 'Status', sortable: true },
          { key: 'actions', label: 'Operacje' },
          { key: 'functions', label: 'Funkcje' }
        ],
        items2: [
          {
            date: 'Stephen Hawking',
            result: 1
          },
          {
            date: 'Stephen Hawking',
            result: 1
          },
          {
            date: 'Stephen Hawking',
            result: 1
          },
          {
            date: 'Stephen Hawking',
            result: 1
          },
          {
            date: 'Stephen Hawking',
            result: 1
          },
          {
            date: 'Stephen Hawking',
            result: 1
          }
        ],
        fields2: [
          { key: 'date', label: '' },
          { key: 'result', label: '' }
        ]
      }
    },
    methods : {
      rowClass(item, type) {
        if (type === 'row-top') {
          return 'sub-header'
        }
        return ''
      }
    },
    mounted () {
      // Set the initial number of items
      this.totalRows = this.items.length
    }
  }
</script>


<style scoped>

</style>
